import { useEffect, type ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";

interface PageProps {
  children: ReactNode;
}

const Page = ({ children }: PageProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Backspace") {
        event.preventDefault();
        navigate({ to: "/" });
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [navigate]);

  return <div style={{ backgroundColor: "black" }}>{children}</div>;
};

export default Page;
